/**
 * 空值
 */
export function inputEmpty(txt, trigger = "blur") {
  return {
    required: true,
    message: `${txt}不能为空`,
    trigger
  };
}
export function changeEmpty(txt, action="选择") {
  return {
    required: true,
    message: `请${action + txt}`,
    trigger: "change"
  };
}

/**
 * 邮箱
 */
export function checkMailbox() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (value && !reg.test(value)) {
        return callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * 手机号
 */
export function checkMobile() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^[1][3456789][0-9]{9}$/;
      if (value && !reg.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * 联系电话
 */
export function checkTelephone() {
  return {
    validator: (rule, value, callback) => {
      let mobileReg = /^[1][345789][0-9]{9}$/;
      let landLineReg = /^0\d{2,3}-[1-9]\d{6,7}$/;
      if (value && !mobileReg.test(value) && !landLineReg.test(value)) {
        return callback(new Error("请输入正确的手机号或座机号"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * 身份证号
 */
export function checkIdNumber() {
  return {
    validator: (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value && !reg.test(value)) {
        return callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * IP地址
 */
export function checkIp() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      if (value && !reg.test(value)) {
        return callback(new Error("请输入正确的IP地址"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * MAC地址
 */
export function checkMac() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}$/;
      if (value && !reg.test(value)) {
        return callback(new Error("请输入正确的MAC地址"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * 域名
 */
export function checkDomain() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的域名"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * IP地址和域名
 */
export function checkIpDomain() {
  return {
    validator: (rule, value, callback) => {
      let ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      let domainReg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
      if (value && !ipReg.test(value) && !domainReg.test(value)) {
        return callback(new Error("请输入正确的域名或IP地址"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * URL
 */
export function checkUrL() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^(?=^.{3,255}$)(http(s)?:\/\/)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的URL"));
      } else {
        callback();
      }
    },
    trigger: "blur"
  };
}

/**
 * 数字检测
 */
export function checkNumber() {
  return {
    validator: (rule, value, callback) => {
      let reg1 = /^\d+$/;
      let reg2 = /^0\d+$/;
      if (value && !reg1.test(value)) {
        callback(new Error('只能为数字'));
      } else if (value && reg2.test(value)) {
        callback(new Error('数字格式错误'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 纯数字
 */
export function checkPureNumber() {
  return {
    validator: (rule, value, callback) => {
      let res = /^\d*$/;
      if (value && res.test(value)) {
        callback(new Error('不能为纯数字'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 长度检测
 */
export function checkLength(length) {
  return {
    validator: (rule, value, callback) => {
      if (value && value.length < length) {
        callback(new Error('长度不能低于'+length+'位'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 范围检测
 */
export function checkRange(min, max) {
  return {
    validator: (rule, value, callback) => {
      if (value && (+value < min || +value > max)) {
        callback(new Error('范围：'+min+" - "+max));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 版本号检测
 */
export function checkVersion() {
  return {
    validator: (rule, value, callback) => {
      let reg = /^\d{2}\.\d{2}\.\d{2}[vt]$/i;
      if (value && !reg.test(value)) {
        callback(new Error('格式：xx.xx.xx(V,T)'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 应用标识检测
 */
export function checkProduct() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[a-zA-Z0-9_]+$/;
      if (value && !res.test(value)) {
        callback(new Error('只能是字母、数字和下划线_'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 用户名
 */
export function checkUsername() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[a-zA-Z0-9_-]{6,18}$/;
      if (value && !res.test(value)) {
        callback(new Error('规则为6-18位字母、数字和下划线_及破折号-'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 密码
 */
export function checkPwd() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[a-zA-Z0-9]{8,14}$/;
      if (value && !res.test(value)) {
        callback(new Error('规则为8-14位数字、字母'));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 昵称
 */
export function checkNickName() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[\u4E00-\u9FA5a-zA-Z0-9_-]{1,18}$/;
      if (value && !res.test(value)) {
        callback(new Error(`规则为1-18位汉字、字母、数字和下划线_及破折号-`));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * uuid
 */
export function checkUuid() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
      if (value && !res.test(value)) {
        callback(new Error(`请输入正确的激活码`));
      }
      callback();
    },
    trigger: "blur"
  }
}

/**
 * 真实姓名
 */
export function checkRealName() {
  return {
    validator: (rule, value, callback) => {
      let res = /^[\u4e00-\u9fa5a-zA-Z.\s]{1,6}$/;
      if (value && !res.test(value)) {
        callback(new Error(`规则为1-6位汉字、字母和点.`));
      }
      callback();
    },
    trigger: "blur"
  }
}
